import { Link } from "react-router-dom";
import dayjs from "dayjs";

import { GetNotificationsQuery } from "graphql/queries/get-notifications.generated";
import { UpdateNotificationMutationVariables } from "graphql/mutations/update-notification.generated";

interface NotificationProps {
  notification: GetNotificationsQuery['notifications'][number];
  updateNotification: ({ variables }: { variables: UpdateNotificationMutationVariables }) => void;
}

const HandoverStateChangeNotification = ({ notification, updateNotification }: NotificationProps) => {
  const handleNotificationClick = (archived = false) => {
    updateNotification({ variables: { id: notification.id, _set: { viewed: true, archived } } });
  };

  const handleNotificationReset = () => {
    updateNotification({ variables: { id: notification.id, _set: { viewed: false, archived: false } } });
  };

  return (
    <div className="s-c-notification handover-state-change-notification">
      <div className="notification-img-outer-wrapper">
        <div className="notification-img-inner-wrapper">
          <img
            className="notification-img"
            src={`${process.env.PUBLIC_URL}/assets/images/icons/package-plus.svg`}
            alt=""
          />
        </div>
      </div>
      <Link className="s-c-n-content" to={notification.deeplink || '/dashboard'} onClick={() => handleNotificationClick()}>
        <div className={`s-c-n-title${notification.viewed ? '' : '-unread'}`}>{notification.payload.title}</div>
        <div className="s-c-n-property">{notification.body}</div>
        <div className="s-c-n-time">{dayjs(notification.created_at).format("ddd, MMM D [at] h:mm A")}</div>
      </Link>
      {notification.archived ? (
        <div className="notification-reset-btn" onClick={() => handleNotificationReset()}>MARK AS UNREAD</div>
      ) : (
        <div className="notification-clear-btn" onClick={() => handleNotificationClick(true)}>CLEAR</div>
      )}
    </div>
  );
};

export default HandoverStateChangeNotification;
